import React, { memo } from 'react';
import { ModernVideoModelNode } from './ModernVideoModelNode';
import { GEMINI_OMNI_FLASH_CONFIG } from './videoModelConfigs';

export const GeminiOmniFlashVideoNode = memo(props => (
  <ModernVideoModelNode {...props} config={GEMINI_OMNI_FLASH_CONFIG} />
));
